import * as React from 'react';
import classNames from 'classnames';
import styles from './rating.module.scss';

interface IRating {
    value: number;
}

const Rating: React.FC<IRating> = ({ value }) => {
    const roundedValue = Math.round(value / 0.5) * 0.5;

    const stars = (): JSX.Element[] => {
        const ret: JSX.Element[] = [];
        let restValue = roundedValue + 1;

        for (let i = 0; 4 >= i; i++) {
            restValue -= 1;
            if (1 <= restValue) {
                ret.push(<span key={i} className={classNames(styles.star, styles.fullStar)}></span>);
                continue;
            }
            if (0 < restValue) {
                ret.push(<span key={i} className={classNames(styles.star, styles.halfStar)}></span>);
                continue;
            }
            ret.push(<span key={i} className={classNames(styles.star, styles.emptyStar)}></span>);
        }

        return ret;
    };

    return <div className={styles.stars}>{stars()}</div>;
};

export default Rating;
